<div class="modal-overlay"
    *ngIf="showModal"
    (click)="close()"></div>
<div class="po-modal"
    *ngIf="showModal"
    [class.show]="showModal">
    <div class="po-modal-header">
        <div class="d-flex align-items-center gap-3">
            <div class="header-icon-wrapper">
                <i class="material-icons text-success">assignment</i>
            </div>
            <div>
                <h5 class="fw-bold mb-0">Create Purchase Order</h5>
                <p class="text-muted small mb-0">Please confirm to generate a new PO</p>
            </div>
        </div>
        <button class="btn-close"
            (click)="close()"></button>
    </div>

    <div class="po-modal-body">
        <!-- Form Fields -->
        <div class="row g-3 mb-4">
            <div class="col-md-3">
                <label class="form-label">Supplier Name</label>
                <input type="text"
                    class="form-control"
                    [value]="supplier?.name"
                    readonly>
            </div>
            <div class="col-md-3">
                <label class="form-label">Supplier Alias</label>
                <input type="text"
                    class="form-control"
                    [(ngModel)]="supplierAlias"
                    placeholder="Hans Traders">
            </div>
            <div class="col-md-3">
                <label class="form-label">Purchase Order No. <i class="material-icons align-middle"
                        style="font-size: 14px; opacity: 0.7;">settings</i></label>
                <input type="text"
                    class="form-control"
                    [(ngModel)]="poNumber">
            </div>
            <div class="col-md-3">
                <label class="form-label">Date</label>
                <div class="input-group date-input">
                    <span class="input-group-text"><i class="material-icons calendar-icon">calendar_today</i></span>
                    <input type="text"
                        class="form-control"
                        [value]="poDate | date:'dd-MM-yyyy'"
                        disabled>
                </div>
            </div>
        </div>

        <!-- Additional Fields Accordion -->
        <div class="additional-fields-section rounded overflow-hidden mb-4"
            [class.expanded]="showAdditionalFields">
            <div class="additional-fields-header d-flex align-items-center justify-content-between"
                (click)="toggleAdditionalFields()"
                style="cursor: pointer;">
                <div class="d-flex align-items-center gap-2">
                    <span class="fw-semibold">Additional Fields</span>
                    <i class="material-icons">{{ showAdditionalFields ? 'remove_circle_outline' : 'add_circle_outline'
                        }}</i>
                </div>
            </div>

            <div class="additional-fields-content border-top p-3"
                *ngIf="showAdditionalFields">
                <div class="row g-4">
                    <!-- Your Logo -->
                    <div class="col-md-6">
                        <label class="form-label">Your Logo</label>
                        <div class="logo-upload-container d-flex flex-column align-items-center justify-content-center p-3"
                            [class.dragging]="isDragging"
                            (dragover)="onDragOver($event)"
                            (dragleave)="onDragLeave($event)"
                            (drop)="onLogoDropped($event)"
                            (click)="logoInput.click()">

                            <!-- Hidden File Input -->
                            <input type="file"
                                #logoInput
                                (change)="onLogoSelected($event)"
                                accept="image/*"
                                style="display: none;">

                            <!-- Image Preview -->
                            <ng-container *ngIf="logoPreview">
                                <div
                                    class="logo-preview-wrapper position-relative w-100 h-100 d-flex align-items-center justify-content-center">
                                    <img [src]="logoPreview"
                                        alt="Logo Preview"
                                        class="logo-preview-img">
                                    <button
                                        class="btn btn-sm btn-danger position-absolute top-0 end-0 m-2 rounded-circle shadow-sm"
                                        (click)="$event.stopPropagation(); removeLogo()"
                                        style="width: 28px; height: 28px; padding: 0; line-height: 1;">
                                        <i class="material-icons"
                                            style="font-size: 16px;">close</i>
                                    </button>
                                </div>
                            </ng-container>

                            <!-- Upload Placeholder -->
                            <ng-container *ngIf="!logoPreview">
                                <img src="https://img.icons8.com/isometric/100/folder-invoices.png"
                                    alt="upload">
                                <div class="fw-bold mt-2">Drag and Drop File / <span class="text-warning">Browse
                                        Files</span></div>
                                <div class="text-muted">jpg, png files allowed. Max size 2 MB</div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Contact Info -->
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label class="form-label">GST Number</label>
                            <input type="text"
                                class="form-control"
                                [class.is-invalid]="errors.gstNumber"
                                placeholder="Enter GST Number here"
                                [(ngModel)]="additionalFields.gstNumber"
                                (input)="validateGst()">
                            <div class="invalid-feedback"
                                *ngIf="errors.gstNumber">
                                Please enter a valid 15-digit GST number.
                            </div>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">Mobile Number</label>
                            <input type="text"
                                class="form-control"
                                [class.is-invalid]="errors.mobileNumber"
                                placeholder="Enter Mobile Number here"
                                [(ngModel)]="additionalFields.mobileNumber"
                                (input)="validateMobile()">
                            <div class="invalid-feedback"
                                *ngIf="errors.mobileNumber">
                                Please enter a valid 10-digit mobile number.
                            </div>
                        </div>
                        <div class="mb-0">
                            <label class="form-label">Email</label>
                            <input type="email"
                                class="form-control"
                                [class.is-invalid]="errors.email"
                                placeholder="Enter Email here"
                                [(ngModel)]="additionalFields.email"
                                (input)="validateEmail()">
                            <div class="invalid-feedback"
                                *ngIf="errors.email">
                                Please enter a valid email address.
                            </div>
                        </div>
                    </div>

                    <!-- Addresses -->
                    <div class="col-md-6">
                        <label class="form-label">Billing Address</label>
                        <textarea class="form-control"
                            rows="5"
                            placeholder="Enter Address here"
                            [(ngModel)]="additionalFields.billingAddress"></textarea>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Shipping Address</label>
                        <textarea class="form-control"
                            rows="5"
                            placeholder="Enter Address here"
                            [(ngModel)]="additionalFields.shippingAddress"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <!-- Items Table -->
        <div class="items-table-wrapper rounded overflow-hidden">
            <table class="table table-hover mb-0">
                <thead>
                    <tr>
                        <th class="border-0">Items <i class="material-icons align-middle"
                                style="font-size: 14px;">arrow_upward</i></th>
                        <th class="border-0 text-center">Unit</th>
                        <th class="border-0 text-center">Qty</th>
                        <th class="border-0 text-center">Rate Per Unit</th>
                        <th class="border-0 text-end px-4">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of poItems; let i = index">
                        <td class="align-middle">
                            <div class="fw-semibold text-dark">{{ item._itemName }}</div>
                        </td>
                        <td class="align-middle text-center">
                            <input type="text"
                                class="form-control form-control-sm text-center border-rounded mx-auto bg-light"
                                style="width: 70px;"
                                [(ngModel)]="item.unit">
                        </td>
                        <td class="align-middle text-center">
                            <input type="number"
                                class="form-control form-control-sm text-center border-rounded mx-auto"
                                style="width: 70px;"
                                [(ngModel)]="item.quantity"
                                (change)="calculateTotals()">
                        </td>
                        <td class="align-middle text-center">
                            <input type="number"
                                class="form-control form-control-sm text-center border-rounded mx-auto"
                                style="width: 90px;"
                                [(ngModel)]="item.rate"
                                (change)="calculateTotals()">
                        </td>
                        <td class="align-middle text-end fw-bold px-4">
                            ₹{{ (item.quantity * (item.rate || 0)) | number:'1.2-2' }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="po-modal-footer">
        <div class="d-flex justify-content-end gap-3 align-items-center">
            <div class="me-4 text-end">
                <div class="grand-total-label">Grand Total</div>
                <div class="grand-total-value">₹{{ grandTotal | number:'1.2-2' }}</div>
            </div>
            <button class="btn btn-outline-secondary"
                (click)="close()">Cancel</button>
            <button class="btn btn-outline-primary"
                (click)="openPreview()"
                [disabled]="poItems.length === 0">Preview</button>
            <button class="btn btn-warning d-flex align-items-center gap-2"
                (click)="generatePO()"
                [disabled]="poItems.length === 0 || isGeneratingPO">
                <span *ngIf="isGeneratingPO"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"></span>
                {{ isGeneratingPO ? 'Generating...' : 'Generate' }}
            </button>
        </div>
    </div>
</div>

<!-- Purchase Order Preview Modal -->
<div class="modal-overlay preview-overlay"
    *ngIf="showPreviewModal"
    (click)="closePreview()"></div>
<div class="po-preview-modal"
    *ngIf="showPreviewModal"
    [class.show]="showPreviewModal">
    <div class="preview-header border-bottom">
        <h5 class="mb-0 fw-bold">PO Preview</h5>
        <button class="btn-close"
            (click)="closePreview()"></button>
    </div>

    <div class="preview-body">
        <!-- Re-use the printable document template -->
        <ng-container *ngTemplateOutlet="poDocumentTemplate"></ng-container>
    </div>

    <div class="preview-footer border-top p-3 d-flex justify-content-end gap-2 bg-light">
        <button class="btn btn-secondary px-4"
            (click)="closePreview()">Close</button>
        <button class="btn btn-warning px-4 fw-bold d-flex align-items-center gap-2"
            (click)="generatePO()"
            [disabled]="isGeneratingPO">
            <span *ngIf="isGeneratingPO"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"></span>
            {{ isGeneratingPO ? 'Generating...' : 'Generate PO' }}
        </button>
    </div>
</div>

<!-- Printable Hidden Section -->
<div class="printable-po-wrapper"
    id="printable-po-wrapper">
    <ng-container *ngTemplateOutlet="poDocumentTemplate"></ng-container>
</div>

<!-- PO Success Modal -->
<div class="modal-overlay success-overlay"
    *ngIf="showSuccessModal"
    (click)="closeSuccessModal()"></div>
<div class="po-success-modal"
    *ngIf="showSuccessModal"
    [class.show]="showSuccessModal">
    <div class="success-header p-3 pb-0 text-end">
        <button class="btn-close"
            (click)="closeSuccessModal()"></button>
    </div>

    <div class="success-body text-center p-4 pt-0">
        <div class="success-icon-wrapper mb-3">
            <div class="success-circle">
                <i class="material-icons">check</i>
            </div>
            <div class="success-inner-card">
                <i class="material-icons"
                    style="font-size: 40px; color: #10B981;">description</i>
            </div>
        </div>

        <h4 class="fw-bold mb-1">PO Generated Successfully</h4>
        <p class="text-muted small mb-4">PO Number: {{ poNumber }}</p>

        <!-- Share Options -->
        <div class="share-options-container"
            style="pointer-events: none; opacity: 0.5;">
            <!-- WhatsApp Option -->
            <div class="share-card mb-3 p-3 border rounded d-flex align-items-center gap-3">
                <div class="whatsapp-icon">
                    <img src="https://img.icons8.com/color/48/whatsapp--v1.png"
                        alt="whatsapp"
                        style="width: 32px;">
                </div>
                <div class="flex-grow-1 text-start">
                    <div class="fw-bold small">Send via Whatsapp</div>
                    <div class="text-muted"
                        style="font-size: 11px;">Send PO via Whatsapp to the supplier</div>
                    <div class="input-group mt-2">
                        <input type="text"
                            class="form-control form-control-sm"
                            placeholder="E.g., 9898266555"
                            [(ngModel)]="additionalFields.mobileNumber">
                        <button class="btn btn-outline-secondary btn-sm px-3"
                            (click)="sendViaWhatsApp()">Send</button>
                    </div>
                </div>
            </div>

            <div class="divider text-center my-3">
                <span class="bg-white px-3 text-muted small">or</span>
            </div>

            <!-- Email Option -->
            <div class="share-card mb-4 p-3 border rounded d-flex align-items-center gap-3">
                <div class="email-icon">
                    <img src="https://img.icons8.com/color/48/gmail-new.png"
                        alt="email"
                        style="width: 32px;">
                </div>
                <div class="flex-grow-1 text-start">
                    <div class="fw-bold small">Send via Email</div>
                    <div class="text-muted"
                        style="font-size: 11px;">Send PO via Email to Supplier</div>
                    <div class="input-group mt-2">
                        <input type="email"
                            class="form-control form-control-sm"
                            placeholder="po@hanstraders.in"
                            [(ngModel)]="additionalFields.email">
                        <button class="btn btn-outline-secondary btn-sm px-3"
                            (click)="sendViaEmail()">Send</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center gap-3 pt-3">
            <button class="btn btn-outline-secondary px-4 py-2 fw-semibold"
                (click)="closeSuccessModal()"
                style="border-radius: 8px;">Close</button>
            <button class="btn btn-warning px-4 py-2 fw-bold d-flex align-items-center gap-2"
                (click)="downloadAsPDF()"
                style="border-radius: 8px;">
                <i class="material-icons">downloading</i>
                Download PO
            </button>
        </div>
    </div>
</div>

<!-- Reusable PO Document Template -->
<ng-template #poDocumentTemplate>
    <div class="po-document">
        <!-- Document Header -->
        <div class="doc-header d-flex align-items-center gap-4 p-3 border">
            <div class="doc-logo"
                *ngIf="logoPreview">
                <img [src]="logoPreview"
                    alt="Business Logo">
            </div>
            <div class="doc-company-info">
                <h2 class="company-name text-danger fw-bold mb-1">{{ entityName || 'Company Name' }}</h2>
                <p class="company-address small mb-0">{{ entityAddress || 'Company Address' }}</p>
            </div>
        </div>

        <!-- PO Title -->
        <div class="doc-title text-center py-1 fw-bold border border-top-0 small">
            PURCHASE ORDER
        </div>

        <!-- Address & Info Section -->
        <div class="row g-0 border border-top-0">
            <div class="col-6 border-end p-3">
                <div class="mb-3">
                    <div class="fw-bold small text-muted text-uppercase mb-1">Bill To</div>
                    <div class="fw-bold">{{ supplier?.name }}</div>
                    <div class="small">{{ supplier?.address || 'Address not available' }}</div>
                </div>
                <div class="mb-3"
                    *ngIf="additionalFields.shippingAddress">
                    <div class="fw-bold small text-muted text-uppercase mb-1">Shipping Address</div>
                    <div class="fw-bold">{{ entityName }}</div>
                    <div class="small">{{ additionalFields.shippingAddress }}</div>
                </div>
                <div class="mb-0"
                    *ngIf="additionalFields.billingAddress">
                    <div class="fw-bold small text-muted text-uppercase mb-1">Billing Address</div>
                    <div class="fw-bold">{{ entityName }}</div>
                    <div class="small">{{ additionalFields.billingAddress }}</div>
                </div>
            </div>
            <div class="col-6 p-3">
                <div class="d-flex justify-content-between mb-2">
                    <span class="small fw-bold">PO Number:</span>
                    <span class="small">{{ poNumber }}</span>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <span class="small fw-bold">PO Date:</span>
                    <span class="small">{{ poDate | date:'dd-MM-yyyy' }}</span>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <span class="small fw-bold">GST:</span>
                    <span class="small">{{ additionalFields.gstNumber }}</span>
                </div>
                <div class="d-flex justify-content-between mb-2">
                    <span class="small fw-bold">Mobile Number:</span>
                    <span class="small">{{ additionalFields.mobileNumber }}</span>
                </div>
                <div class="d-flex justify-content-between">
                    <span class="small fw-bold">Email:</span>
                    <span class="small">{{ additionalFields.email }}</span>
                </div>
            </div>
        </div>

        <!-- Items Table -->
        <div class="row g-0 border border-top-0">
            <table class="table table-bordered mb-0 doc-items-table">
                <thead>
                    <tr class="bg-light">
                        <th class="text-center small py-1"
                            style="width: 50px;">No.</th>
                        <th class="small py-1">Item</th>
                        <th class="text-center small py-1"
                            style="width: 100px;">Qty</th>
                        <th class="text-end small py-1"
                            style="width: 120px;">Rate</th>
                        <th class="text-end small py-1 px-3"
                            style="width: 150px;">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of poItems; let i = index">
                        <td class="text-center small py-2">{{ i + 1 }}</td>
                        <td class="small py-2 text-capitalize">{{ item._itemName }}</td>
                        <td class="text-center small py-2">{{ item.quantity }} {{ item.unit }}</td>
                        <td class="text-end small py-2">₹{{ item.rate | number:'1.2-2' }}</td>
                        <td class="text-end small py-2 px-3">₹{{ (item.quantity * item.rate) | number:'1.2-2' }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="3"
                            rowspan="3"
                            class="border-start-0 border-bottom-0"></td>
                        <td class="text-end fw-bold small py-1">SUBTOTAL</td>
                        <td class="text-end small py-1 px-3">₹{{ grandTotal | number:'1.2-2' }}</td>
                    </tr>
                    <tr>
                        <td class="text-end fw-bold small py-1">Round Off</td>
                        <td class="text-end small py-1 px-3">₹0.00</td>
                    </tr>
                    <tr class="table-active">
                        <td class="text-end fw-bold small py-1">TOTAL AMOUNT</td>
                        <td class="text-end fw-bold small py-1 px-3">₹{{ grandTotal | number:'1.2-2' }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <!-- Footer Section -->
        <div class="row g-0 border border-top-0 p-3">
            <div class="col-8">
                <div class="small fw-bold mb-1">AMOUNT IN WORDS: <span class="text-uppercase">{{ amountInWords }}</span>
                </div>
                <div class="mt-4">
                    <div class="small fw-bold">Notes</div>
                    <div class="text-muted small">Valid for all store location and only.<br>Thank you for shopping</div>
                </div>
                <div class="mt-4 text-muted"
                    style="font-size: 10px;">
                    This is a computer generated receipt
                </div>
            </div>
            <div class="col-4 border text-center p-3 d-flex flex-column align-items-center justify-content-between"
                style="min-height: 120px;">
                <div class="small fw-bold">Authorised signature</div>
                <div class="doc-logo small"
                    style="width: 60px;">
                    <img src="https://img.icons8.com/color/48/signature.png"
                        alt="logo"
                        style="width: 40px; opacity: 0.5;">
                </div>
                <div class="small text-muted"
                    style="font-size: 9px;">For, {{ entityName }}</div>
            </div>
        </div>
    </div>
</ng-template>